// Use $color-blue as loader color
export const loaderColor = '#002b8f';